import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { ASYNC_STATE } from "../../../../constants/Constants";
import { loadReceipt, sendReceiptEmail } from "../../../../domain/payment/paymentActions";
import { FormattedDate, FormattedNumber, FormattedMessage, defineMessages } from "react-intl";
import StatusMessage from "../../../presentational/StatusMessage";
import * as StatusMessages from "../../../../constants/StatusMessages";
import { Link } from "react-router";
import "./Receipt.less";
import DetailList, { DetailListItem } from "../../../presentational/DetailList/DetailList";
import ContactInfo from "../../../presentational/ContactInfo/ContactInfo";
import PaymentCancelDisclosure from "../../../presentational/PaymentCancelDisclosure/PaymentCancelDisclosure";
import { showCancelDisclosure } from "../../../../domain/payment/paymentUtils";
import moment from "moment";
import AccountNumber from "assets/scripts/components/presentational/AccountNumber/AccountNumber";
import sumBy from "lodash/sumBy";
import PaymentAmountTable from "assets/scripts/components/presentational/PaymentAmountTable/PaymentAmountTable";
import track from "react-tracking";
import GoogleReviewMessage from "assets/scripts/components/presentational/GoogleReviewMessage/GoogleReviewMessage";
const messages = defineMessages({
    paymentAmount: {
        id: "receipt.paymentAmount",
        defaultMessage: "Payment Amount"
    },
    totalPaymentAmount: {
        id: "receipt.totalPaymentAmount",
        defaultMessage: "Total Payment Amount"
    },
    paymentDate: {
        id: "receipt.paymentDate",
        defaultMessage: "Payment Date"
    },
    creditor: {
        id: "receipt.creditor",
        defaultMessage: "Creditor"
    },
    creditorAccountNumber: {
        id: "receipt.creditorAccountNumber",
        defaultMessage: "Creditor Account Number"
    },
    confirmationNumber: {
        id: "receipt.confirmationNumber",
        defaultMessage: "Confirmation Number"
    },
    emailSent: {
        id: "receipt.emailSent",
        defaultMessage: "This receipt has been sent to your email address."
    }
});
const Summary = ({ receipt, disableDone, disableEmail, sendEmailClick }) => {
    if (!receipt.success) {
        return (<StatusMessage isError isActive customMessage={StatusMessages.PAYMENT.PAYMENT_FAILURE} domain="payment"/>);
    }
    const totalAmount = sumBy(receipt.amounts, it => it.amount);
    const single = receipt.amounts.length === 1 ? receipt.amounts[0] : null;
    return (<div className="receipt-container">
			<div className="vr vr_x5">
				<div className="text">
					<FormattedMessage tagName="p" id="receipt.thanks" defaultMessage={"Thank you! Your payment has been successfully submitted."} values={{
        amount: totalAmount
    }}/>
					{receipt.emailReceipt && process.env.CLIENT !== "CapOne" && (<FormattedMessage tagName="p" id="receipt.email" defaultMessage="This receipt has also been sent to your email address."/>)}
				</div>
			</div>
			<div className="vr vr_x4">
				<DetailList>
					<DetailListItem label={single ? messages.paymentAmount : messages.totalPaymentAmount}>
						<FormattedNumber value={totalAmount} style="currency" currency="USD"/>
					</DetailListItem>
					{receipt.paymentDateUtc != null && (<DetailListItem label={messages.paymentDate}>
							<FormattedDate value={receipt.paymentDateUtc}/>
						</DetailListItem>)}
					{single != null && (<Fragment>
							{!!single.creditor && (<DetailListItem label={messages.creditor}>
									{single.creditor}
								</DetailListItem>)}
							{process.env.CLIENT == null && !!single.accountNumber && (<DetailListItem label={messages.creditorAccountNumber}>
									<AccountNumber value={single.accountNumber}/>
								</DetailListItem>)}
						</Fragment>)}
					<DetailListItem label={messages.confirmationNumber}>
						{receipt.confirmationNumber}
					</DetailListItem>
				</DetailList>
			</div>

			{receipt.amounts.length > 1 && (<div className="vr vr_x4">
					<PaymentAmountTable amounts={receipt.amounts}/>
				</div>)}

			<div className="vr vr_x4">
				<div className="tCombForm">
					{process.env.CLIENT !== "CapOne" && (<div className="formGroupContainer-btn receiptButtons">
						{!disableDone && (<Fragment>
								<Link className="btn mix-btn_fixedWidth btn-action" to={`/secured/account/${receipt.payableId}`}>
									<FormattedMessage id="forms.receipt.done" defaultMessage="Done"/>
								</Link>
								{" "}
							</Fragment>)}
						<button className="btn mix-btn_fixedWidth btn-action" onClick={() => window.print()}>
							<FormattedMessage id="forms.receipt.print" defaultMessage="Print"/>
						</button>
					</div>)}
					{process.env.CLIENT === "CapOne" && (<div className="formGroupContainer-btn receiptButtons">
						{!disableDone && (<Fragment>
								<Link className="btn mix-btn_fixedWidth_3 btn-action" to={`/secured/account/${receipt.payableId}`}>
									<FormattedMessage id="forms.receipt.done" defaultMessage="Done"/>
								</Link>
								{" "}
							</Fragment>)}
						<button className="btn mix-btn_fixedWidth_3 btn-action" onClick={() => window.print()}>
							<FormattedMessage id="forms.receipt.print" defaultMessage="Print"/>
						</button>
						<button className="btn mix-btn_fixedWidth_3 btn-action" disabled={disableEmail} onClick={() => sendEmailClick()}>
							<FormattedMessage id="forms.receipt.email" defaultMessage="Email Receipt"/>
						</button>
					</div>)}
				</div>
			</div>

			<div className="vr vr_x2 text mix-text_small">
				<ContactInfo />
				<FormattedMessage tagName="p" id="receipt.allow" defaultMessage={"Please allow up to 2 business days after the payment date for your "
        + "payment to be reflected on your account."}/>
				{showCancelDisclosure(receipt.paymentDateUtc == null ? null : moment(receipt.paymentDateUtc)) && (<PaymentCancelDisclosure />)}
				{receipt.showGoogleReviewMessage && (<GoogleReviewMessage />)}
			</div>
		</div>);
};
export class ReceiptBase extends Component {
    componentDidMount() {
        this._loadCheck();
        if (!this.state) {
            this.setState({ disableEmail: false, emailSent: false });
        }
    }
    componentDidUpdate() {
        this._loadCheck();
    }
    async onSendEmailClick() {
        this.setState({ disableEmail: true });
        await this.props.sendEmail(+this.props.params.paymentId);
        this.setState({ emailSent: true });
    }
    render() {
        const { props } = this;
        const { loadState } = props;
        return (<div className="wrapper wrapper_narrowPlus mix-content_centerText">
				<div className="vr vr_x4">
					<h1 className="hdg js-pageHeader">
						<FormattedMessage id="receipt.header" defaultMessage="Payment Confirmation"/>
					</h1>
				</div>
				<StatusMessage customMessage={messages.emailSent} isActive={this.state?.emailSent ?? false}/>
				<StatusMessage isLoad isActive={loadState === ASYNC_STATE.NONE || loadState === ASYNC_STATE.PENDING}/>
				<StatusMessage isError isActive={loadState === ASYNC_STATE.REJECTED} customMessage={StatusMessages.PAYMENT.LOAD_RECEIPT_ERROR_INTRO} error={props.error} domain="payment"/>
				{loadState === ASYNC_STATE.RESOLVED && (<Summary receipt={props.receipt} disableDone={props.disableDone} disableEmail={this.state?.disableEmail} sendEmailClick={() => this.onSendEmailClick()}/>)}
			</div>);
    }
    _loadCheck() {
        if (this.props.needsLoad) {
            this.props.load(Number(this.props.params.paymentId));
        }
    }
}
const mapStateToProps = (state, ownProps) => {
    const { receipt } = state.payment;
    const wrongId = receipt.id !== Number(ownProps.params.paymentId);
    return {
        loadState: wrongId ? ASYNC_STATE.NONE : receipt.state,
        receipt: receipt.data,
        error: receipt.error,
        needsLoad: wrongId || receipt.state === ASYNC_STATE.NONE
    };
};
const bindActionsToProps = {
    load: loadReceipt,
    sendEmail: sendReceiptEmail
};
export default track({ page: "Receipt" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(ReceiptBase));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Receipt/Receipt.tsx